import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'

import './Impressum.css'
import './MImpressum.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'


export default function Impressum() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={""} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Impressum</title>
                <meta property="og:title" content="Impressum" />
                <meta property="og:description" content="Hier findest du unser Impressum" />
                <meta name="description" content="Hier findest du unser Impressum" />
            </Helmet>
            <section className='sec_next' id='sec_next--impressum'>
                <div className='sec_next_cont' id="sec_next--impressum--cont" style={{ wordBreak: "break-word", textAlign: "justify" }}>
                    <br /><br />
                    <div className='backbtn'><a href='/rechtliches'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>

                    <h2>Impressum</h2>
                    <h3>1. Gültigkeit</h3>
                    <p>Dieses Impressum gilt für die ToNetwork UG (haftungsbeschränkt) (im Folgenden "ToN") betreffenden Internetseiten und Dienste (im Folgenden "Website"). Außerdem gilt das Impressum für die von ToN betriebenen Socialmedia Kanäle.</p>

                    <h3>2. Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)</h3>
                    <p>ToNetwork UG (haftungsbeschränkt)<br />
                        Im Moos 5<br />
                        87749 Hawangen<br />
                        <br />
                        📧 E-Mail: <a href="mailto:info@tonetwork.de">info@tonetwork.de</a><br />
                        📞 Telefon: <a href='tel:+4983324908872'>+49 8332 4908872</a><br />
                        <br />
                        Vertretungsberechtigt:<br />
                        David Adrian Heidl (Geschäftsführender Gesellschafter)<br />
                        <br />
                        Amtsgericht Memmingen HRB 19138<br />
                        Ust.-Id.-Nr: DE 341245040<br />
                        Sitz: 87749 Hawangen<br />
                    </p>

                    <h3>3. Verantwortlich für den Inhalt nach § 55 Abs 2 RStV:</h3>
                    <p>David Adrian Heidl</p>

                    <h3>4. Haftung für Inhalte</h3>
                    <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.<br />
                    </p>

                    <h3>5. Haftung für Links</h3>
                    <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br />
                    </p>

                    <h3>6. Urheberrecht</h3>
                    <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.<br />
                        <br />
                        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.<br />
                        <br />
                        Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.<br />
                    </p>

                    <h3>7. Verwendete Icons und Bilder</h3>
                    <p>
                        Die Bilder wurden teilweise mit KI generiert. Hierfür wurde DALL-E von OpenAI verwendet.<br />
                        Hintergrundbild auf der Startseite: Foto von <a target="_blank" href="https://unsplash.com/de/@goshua13?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Joshua Aragon</a> auf <a target="_blank" href="https://unsplash.com/de/fotos/laptop-eingeschaltet-BMnhuwFYr7w?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>

                    </p>

                    <h3>8. Entwickler der Webseite</h3>
                    <p>ToNetwork UG (haftungsbeschränkt)<br />
                        <a href="https://tonetwork.de">tonetwork.de</a><br />
                        Im Moos 5<br />
                        87749 Hawangen<br />
                        <br />
                        📧 E-Mail: <a href="mailto:info@tonetwork.de">info@tonetwork.de</a><br />
                        📞 Telefon: <a href='tel:+4983324908872'>+49 8332 4908872</a><br />
                    </p>
                    <h3>9. Stand dieses Impressums</h3>
                    <p>Dieses Impressum wurde am 12.06.2025 erstellt.</p>

                </div>
            </section >

            <MainFooter />
        </div >
    )
}